<template lang="pug">
  .column.m-bottom-2
    .row.middle.m-bottom-05
      simple-svg.m-right-1(
        :class='field.type === kreaCustomFieldTypes.resource ? "black-icon" : "dark-gray-icon"'
        :filepath='customFieldIcon' width='22px' height='22px'
      )
      label.text-small.dark-gray {{ field.customKreaFieldName }}
    p.text-normal.m-left-3 {{ fieldValue }}
</template>

<script>
import { mapState } from 'vuex'
import { kreaCustomFieldTypes } from '@/constants/kreaCustom'
import customFieldIcon from '@/assets/ic_custom_field.svg'

export default {
  props: {
    type: { type: String },
    field: { type: Object }
  },
  data() {
    return {
      customFieldIcon,
      kreaCustomFieldTypes
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo.userInfo
    }),
    fieldValue() {
      const values = this.field.values.map(field => field.name)
      return values.join(', ')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
